import React from 'react';

function MySubcription({ user }) {
  return (
    <section className=''>
      <h3 className='font-semibold mb-4 pb-3 border-b-hf'>My Subscription</h3>
      <p className='flex flex-row justify-between pb-2 gap-2 items-center'>
        <span className='text-s-bk text-sm'> Status:</span>
        <span className='text-b-mc flex flex-row gap-2 bg-b-mct py-1 px-2 items-center'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 1024 1024'
            className='text-b-mc'
          >
            <path
              fill='currentColor'
              d='M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z'
            />
          </svg>

          {user?.subscriptions[0]?.subscription_status?.name}
        </span>
      </p>
      <p className='flex flex-row justify-between pb-2 gap-2 items-center'>
        <span className='text-s-bk text-sm'>Subcription type:</span>
        <span>{user?.subscriptions[0]?.subscription_type?.name}</span>
      </p>
      <p className='flex flex-row justify-between pb-2 gap-2 items-center'>
        <span className='text-s-bk text-sm'> Duration:</span>
        <span className='capitalize'>
          {user?.subscriptions[0]?.subscription_type?.duration_text}
        </span>
      </p>
      <p className='flex flex-row justify-between pb-2 gap-2 items-center'>
        <span className='text-s-bk text-sm'> Referral commisssion:</span>
        <span>
          {user?.subscriptions[0]?.subscription_type?.referral_commission}
        </span>
      </p>
      <p className='flex flex-row justify-between pb-2 gap-2 items-center'>
        <span className='text-s-bk text-sm'> Description:</span>
        <span className='capitalize'>
          {user?.subscriptions[0]?.subscription_type?.description}
        </span>
      </p>
    </section>
  );
}

export default MySubcription;
